/**
 * Filter operator helpers shared by the builder and the filter row.
 * Operator names match the backend's OPS_BY_TYPE; the catalog's ops_by_type
 * is the source of truth for which apply to a field type.
 */

export const OP_VALUE_SHAPE = {
  eq: 'scalar',
  ne: 'scalar',
  gt: 'scalar',
  gte: 'scalar',
  lt: 'scalar',
  lte: 'scalar',
  contains: 'scalar',
  not_contains: 'scalar',
  starts_with: 'scalar',
  ends_with: 'scalar',
  between: 'pair',
  in: 'list',
  not_in: 'list',
  is_null: 'none',
  is_not_null: 'none',
  is_true: 'none',
  is_false: 'none',
};

export const OP_LABELS = {
  eq: 'is',
  ne: 'is not',
  gt: 'greater than',
  gte: 'on or after / at least',
  lt: 'less than',
  lte: 'on or before / at most',
  contains: 'contains',
  not_contains: 'does not contain',
  starts_with: 'starts with',
  ends_with: 'ends with',
  between: 'between',
  in: 'is any of',
  not_in: 'is none of',
  is_null: 'is empty',
  is_not_null: 'is not empty',
  is_true: 'is yes',
  is_false: 'is no',
};

export function shapeOf(op) {
  return OP_VALUE_SHAPE[op] || 'scalar';
}

export function defaultOpForType(type, opsByType) {
  const ops = (opsByType && opsByType[type]) || [];
  return ops[0] || 'eq';
}

export function emptyValueFor(op) {
  const shape = shapeOf(op);
  if (shape === 'none') return null;
  if (shape === 'pair') return ['', ''];
  if (shape === 'list') return [];
  return '';
}

/** HTML input type for a scalar value of the given field type. */
export function valueInputType(fieldType) {
  if (fieldType === 'date' || fieldType === 'datetime') return 'date';
  if (fieldType === 'integer' || fieldType === 'number' || fieldType === 'money') return 'number';
  return 'text';
}

/** Does this filter have the value it needs? */
export function filterHasValue(filter) {
  const shape = shapeOf(filter.op);
  if (shape === 'none') return true;
  if (shape === 'pair') return Array.isArray(filter.value) && filter.value.length === 2 && filter.value.every((v) => v !== '' && v != null);
  if (shape === 'list') return Array.isArray(filter.value) && filter.value.length > 0;
  return filter.value !== '' && filter.value != null;
}
